// The meta layer's world addon (phase E1): it joins the joined valley's one kernel game through `worldScene`'s addons
// (src/world/scene.ts), as the story does, with no browser imports. The page (src/meta/index.ts) mounts the screens,
// the notices, the tutorials, photo mode and the profile over it.
import type { Conditions } from "@rpg/story";
import type { SpikeContent } from "../content";
import type { WorldAddon } from "../world/scene";
import { readMetaContent } from "./content";
import { createMetaLayer, type MetaLayer } from "./module";

/** The meta layer's addon, and the layer once the world is built. */
export function metaScene(o: { content: SpikeContent; conditions: Conditions }) {
  let layer: MetaLayer | null = null;
  const addon: WorldAddon = (parts) => {
    const l = createMetaLayer({
      content: readMetaContent(o.content, parts.world),
      fight: parts.fight,
      hero: () => {
        const f = parts.rig.hero().feet;
        return { x: f.x, y: f.y, z: f.z };
      },
      conditions: o.conditions,
    });
    layer = l;
    return { modules: [l.module] };
  };
  return {
    addon,
    layer: (): MetaLayer => {
      if (!layer) throw new Error("meta: not set up yet");
      return layer;
    },
  };
}
